module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp23_7016.2dd08eb4.png";